// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"10":"cd1a7070","99":"65b1d7ee","142":"7d791e2c","218":"aef53286","225":"ec5e2387","236":"e0d52b74","307":"2e4b13fe","310":"fbc919a0","315":"1c9e7d94","339":"fead5150","439":"94773d3a","569":"cb862c12","603":"20e890db","975":"0e9f3c8a"}[chunkId] + ".js";
};